module.exports = __webpack_public_path__ + "static/media/transformers.f71d38da.png";